/* tslint:disable */
/* eslint-disable */
/**
 * Business Portal API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface GetOrderDetail200Response
 */
export interface GetOrderDetail200Response {
    /**
     * 更新日時
     * @type {string}
     * @memberof GetOrderDetail200Response
     */
    updateTimestamp: string;
    /**
     * 実行状況 (1:未完了, 2:完了, 3:キャンセル, 4:予約(将来対応), 5:探車失敗)
     * @type {string}
     * @memberof GetOrderDetail200Response
     */
    orderStatus: string;
    /**
     * 配車状態（1:配車中（未応答）, 2:探車失敗, 3:迎車中（現着前）, 4:迎車中（現着済）, 5:実車中, 6:代車要請中, 7:支払完了, 8:支払中（決済失敗）, 9:実車中, 11:利用者キャンセル, 12:事業者キャンセル, 13:QR連携キャンセル）
     * @type {string}
     * @memberof GetOrderDetail200Response
     */
    carDispatchStatus: string;
    /**
     * メモ
     * @type {string}
     * @memberof GetOrderDetail200Response
     */
    text?: string;
    /**
     * 乗客氏名
     * @type {string}
     * @memberof GetOrderDetail200Response
     */
    passengerName?: string;
    /**
     * 会員種別（1：プレミアム会員, 2：一般会員）
     * @type {string}
     * @memberof GetOrderDetail200Response
     */
    memberType?: string;
    /**
     * 乗客電話番号
     * @type {string}
     * @memberof GetOrderDetail200Response
     */
    passengerTel?: string;
    /**
     * 乗客Eメールアドレス
     * @type {string}
     * @memberof GetOrderDetail200Response
     */
    passengerEmail?: string;
    /**
     * 注文番号
     * @type {string}
     * @memberof GetOrderDetail200Response
     */
    orderNo: string;
    /**
     * 顧客ID
     * @type {string}
     * @memberof GetOrderDetail200Response
     */
    customerId?: string;
    /**
     * 依頼元種別（01：S.RIDEアプリ, 09：オペレーター配車）
     * @type {string}
     * @memberof GetOrderDetail200Response
     */
    requestSourceType: string;
    /**
     * 料金種別 (1:メータ運賃, 2:事前確定, 3:事前確定運賃（RS含む）)
     * @type {string}
     * @memberof GetOrderDetail200Response
     */
    fareType: string;
    /**
     * 経路種別 (0:距離優先, 1:時間優先)
     * @type {string}
     * @memberof GetOrderDetail200Response
     */
    routeType?: string;
    /**
     * 注文種別 (01:即時配車, 02:日時指定)
     * @type {string}
     * @memberof GetOrderDetail200Response
     */
    orderType: string;
    /**
     * 定額種別 (1:メーター運賃, 2:定額)
     * @type {string}
     * @memberof GetOrderDetail200Response
     */
    fixedFareCode: string;
    /**
     * 注文日時
     * @type {string}
     * @memberof GetOrderDetail200Response
     */
    orderDate: string;
    /**
     * 出発地住所
     * @type {string}
     * @memberof GetOrderDetail200Response
     */
    departureAddr?: string;
    /**
     * 出発地緯度
     * @type {number}
     * @memberof GetOrderDetail200Response
     */
    departureLat?: number;
    /**
     * 出発地経度
     * @type {number}
     * @memberof GetOrderDetail200Response
     */
    departureLon?: number;
    /**
     * 付け場所
     * @type {string}
     * @memberof GetOrderDetail200Response
     */
    departureMemo?: string;
    /**
     * 目的地住所
     * @type {string}
     * @memberof GetOrderDetail200Response
     */
    destinationAddr?: string;
    /**
     * 目的地緯度
     * @type {number}
     * @memberof GetOrderDetail200Response
     */
    destinationLat?: number;
    /**
     * 目的地経度
     * @type {number}
     * @memberof GetOrderDetail200Response
     */
    destinationLon?: number;
    /**
     * 注文メモ1
     * @type {string}
     * @memberof GetOrderDetail200Response
     */
    orderMemo1?: string;
    /**
     * 注文メモ2
     * @type {string}
     * @memberof GetOrderDetail200Response
     */
    orderMemo2?: string;
    /**
     * 代行要請フラグ
     * @type {boolean}
     * @memberof GetOrderDetail200Response
     */
    substituted: boolean;
    /**
     * 了解日時
     * @type {string}
     * @memberof GetOrderDetail200Response
     */
    carDispatchDate?: string;
    /**
     * 到着予定日時
     * @type {string}
     * @memberof GetOrderDetail200Response
     */
    estimatedDepartureDatetime?: string;
    /**
     * 現着日時
     * @type {string}
     * @memberof GetOrderDetail200Response
     */
    arrivedLocationDate?: string;
    /**
     * 現着地住所
     * @type {string}
     * @memberof GetOrderDetail200Response
     */
    arrivedLocationAddress?: string;
    /**
     * 現着地緯度
     * @type {number}
     * @memberof GetOrderDetail200Response
     */
    arrivedLocationLat?: number;
    /**
     * 現着地経度
     * @type {number}
     * @memberof GetOrderDetail200Response
     */
    arrivedLocationLon?: number;
    /**
     * 実車開始日時
     * @type {string}
     * @memberof GetOrderDetail200Response
     */
    actualDepartureDate?: string;
    /**
     * 実車出発地住所
     * @type {string}
     * @memberof GetOrderDetail200Response
     */
    actualDepartureAddress?: string;
    /**
     * 実車出発地緯度
     * @type {number}
     * @memberof GetOrderDetail200Response
     */
    actualDepartureLat?: number;
    /**
     * 実車出発地経度
     * @type {number}
     * @memberof GetOrderDetail200Response
     */
    actualDepartureLon?: number;
    /**
     * 実車終了日時
     * @type {string}
     * @memberof GetOrderDetail200Response
     */
    actualDestinationDate?: string;
    /**
     * 実車目的地住所
     * @type {string}
     * @memberof GetOrderDetail200Response
     */
    actualDestinationAddress?: string;
    /**
     * 実車目的地緯度
     * @type {number}
     * @memberof GetOrderDetail200Response
     */
    actualDestinationLat?: number;
    /**
     * 実車目的地経度
     * @type {number}
     * @memberof GetOrderDetail200Response
     */
    actualDestinationLon?: number;
    /**
     * 車両状況 (1:配車依頼中, 2:配車応答OK, 3:配車応答NG, 4:タイムアウト, 5:別車両検索中)
     * @type {string}
     * @memberof GetOrderDetail200Response
     */
    activity?: string;
    /**
     * 無線番号
     * @type {string}
     * @memberof GetOrderDetail200Response
     */
    radioNo?: string;
    /**
     * ナンバープレート上部
     * @type {string}
     * @memberof GetOrderDetail200Response
     */
    plateNoUpper?: string;
    /**
     * ナンバープレート下部
     * @type {string}
     * @memberof GetOrderDetail200Response
     */
    plateNoBottom?: string;
    /**
     * 車種コード
     * @type {string}
     * @memberof GetOrderDetail200Response
     */
    carTypeCode?: string;
    /**
     * 車種名
     * @type {string}
     * @memberof GetOrderDetail200Response
     */
    carTypeName?: string;
    /**
     * 車両色RGB値
     * @type {string}
     * @memberof GetOrderDetail200Response
     */
    carRgb?: string;
    /**
     * 乗務員氏名
     * @type {string}
     * @memberof GetOrderDetail200Response
     */
    driverName?: string;
    /**
     * 乗務員ID
     * @type {string}
     * @memberof GetOrderDetail200Response
     */
    driverId?: string;
    /**
     * タクシー会社名(グループ名)
     * @type {string}
     * @memberof GetOrderDetail200Response
     */
    companyName?: string;
    /**
     * タクシー会社コード
     * @type {string}
     * @memberof GetOrderDetail200Response
     */
    companyCode?: string;
    /**
     * タクシー会社名(会社名)
     * @type {string}
     * @memberof GetOrderDetail200Response
     */
    subCompanyName?: string;
    /**
     * タクシー会社ID
     * @type {string}
     * @memberof GetOrderDetail200Response
     */
    subCompanyCode?: string;
    /**
     * タクシー営業所名
     * @type {string}
     * @memberof GetOrderDetail200Response
     */
    salesOfficeName?: string;
    /**
     * タクシー営業所ID
     * @type {string}
     * @memberof GetOrderDetail200Response
     */
    salesOfficeId?: string;
    /**
     * ドア番号
     * @type {string}
     * @memberof GetOrderDetail200Response
     */
    doorNo?: string;
    /**
     * 個人タクシー事業者名
     * @type {string}
     * @memberof GetOrderDetail200Response
     */
    ownerDrivenTaxiName?: string;
    /**
     * 現着メッセージ送信日時
     * @type {string}
     * @memberof GetOrderDetail200Response
     */
    arrivalMessageSentDate?: string;
    /**
     * 希望支払方法 (0:車内支払, 1:アプリ支払（クレカ）, 3:アプリ支払（Apple Pay）, 4:RingoPass支払, 5:後席決済（汎用QR）, 6:アプリ支払（CABカード）, 7:アプリ支払（S.RIDE Biz）, 10:アプリ支払（PayPay）, 11:アプリ支払（auPay）, 12:アプリ支払（d払い）, 13:アプリ支払（R Pay））
     * @type {string}
     * @memberof GetOrderDetail200Response
     */
    desiredPaymentMethod?: string;
    /**
     * 実績支払い方法 (0:車内支払, 1:アプリ支払（クレカ）, 3:アプリ支払（Apple Pay）, 4:RingoPass支払, 5:後席決済（汎用QR）, 6:アプリ支払（CABカード）, 7:アプリ支払（S.RIDE Biz）, 10:アプリ支払（PayPay）, 11:アプリ支払（auPay）, 12:アプリ支払（d払い）, 13:アプリ支払（R Pay））
     * @type {string}
     * @memberof GetOrderDetail200Response
     */
    paymentMethod?: string;
    /**
     * 決済種別 (-1:汎用QR, 0:WechatPay, 1:ALIPay, 2:AEONPay, 3:R Pay, 5:PayPay, 6:メルペイ, 7:d払い, 8:LINEPay, 9:auPay, 10:J-Coin Pay, 11:銀聯QR, 12:Alipay+)
     * @type {string}
     * @memberof GetOrderDetail200Response
     */
    settlementType?: string;
    /**
     * 収受総額
     * @type {number}
     * @memberof GetOrderDetail200Response
     */
    actualFare?: number;
    /**
     * 事前確定運賃
     * @type {number}
     * @memberof GetOrderDetail200Response
     */
    estimateFare?: number;
    /**
     * 有料道路料金
     * @type {number}
     * @memberof GetOrderDetail200Response
     */
    tollroadFee?: number;
    /**
     * キャンセル日時
     * @type {string}
     * @memberof GetOrderDetail200Response
     */
    cancelDate?: string;
    /**
     * キャンセル理由内容
     * @type {string}
     * @memberof GetOrderDetail200Response
     */
    cancelReasonName?: string;
    /**
     * キャンセル料金発生フラグ
     * @type {boolean}
     * @memberof GetOrderDetail200Response
     */
    cancelFeeCollect?: boolean;
}

/**
 * Check if a given object implements the GetOrderDetail200Response interface.
 */
export function instanceOfGetOrderDetail200Response(value: object): value is GetOrderDetail200Response {
    if (!('updateTimestamp' in value) || value['updateTimestamp'] === undefined) return false;
    if (!('orderStatus' in value) || value['orderStatus'] === undefined) return false;
    if (!('carDispatchStatus' in value) || value['carDispatchStatus'] === undefined) return false;
    if (!('orderNo' in value) || value['orderNo'] === undefined) return false;
    if (!('requestSourceType' in value) || value['requestSourceType'] === undefined) return false;
    if (!('fareType' in value) || value['fareType'] === undefined) return false;
    if (!('orderType' in value) || value['orderType'] === undefined) return false;
    if (!('fixedFareCode' in value) || value['fixedFareCode'] === undefined) return false;
    if (!('orderDate' in value) || value['orderDate'] === undefined) return false;
    if (!('substituted' in value) || value['substituted'] === undefined) return false;
    return true;
}

export function GetOrderDetail200ResponseFromJSON(json: any): GetOrderDetail200Response {
    return GetOrderDetail200ResponseFromJSONTyped(json, false);
}

export function GetOrderDetail200ResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetOrderDetail200Response {
    if (json == null) {
        return json;
    }
    return {
        
        'updateTimestamp': json['update_timestamp'],
        'orderStatus': json['order_status'],
        'carDispatchStatus': json['car_dispatch_status'],
        'text': json['text'] == null ? undefined : json['text'],
        'passengerName': json['passenger_name'] == null ? undefined : json['passenger_name'],
        'memberType': json['member_type'] == null ? undefined : json['member_type'],
        'passengerTel': json['passenger_tel'] == null ? undefined : json['passenger_tel'],
        'passengerEmail': json['passenger_email'] == null ? undefined : json['passenger_email'],
        'orderNo': json['order_no'],
        'customerId': json['customer_id'] == null ? undefined : json['customer_id'],
        'requestSourceType': json['request_source_type'],
        'fareType': json['fare_type'],
        'routeType': json['route_type'] == null ? undefined : json['route_type'],
        'orderType': json['order_type'],
        'fixedFareCode': json['fixed_fare_code'],
        'orderDate': json['order_date'],
        'departureAddr': json['departure_addr'] == null ? undefined : json['departure_addr'],
        'departureLat': json['departure_lat'] == null ? undefined : json['departure_lat'],
        'departureLon': json['departure_lon'] == null ? undefined : json['departure_lon'],
        'departureMemo': json['departure_memo'] == null ? undefined : json['departure_memo'],
        'destinationAddr': json['destination_addr'] == null ? undefined : json['destination_addr'],
        'destinationLat': json['destination_lat'] == null ? undefined : json['destination_lat'],
        'destinationLon': json['destination_lon'] == null ? undefined : json['destination_lon'],
        'orderMemo1': json['order_memo1'] == null ? undefined : json['order_memo1'],
        'orderMemo2': json['order_memo2'] == null ? undefined : json['order_memo2'],
        'substituted': json['substituted'],
        'carDispatchDate': json['car_dispatch_date'] == null ? undefined : json['car_dispatch_date'],
        'estimatedDepartureDatetime': json['estimated_departure_datetime'] == null ? undefined : json['estimated_departure_datetime'],
        'arrivedLocationDate': json['arrived_location_date'] == null ? undefined : json['arrived_location_date'],
        'arrivedLocationAddress': json['arrived_location_address'] == null ? undefined : json['arrived_location_address'],
        'arrivedLocationLat': json['arrived_location_lat'] == null ? undefined : json['arrived_location_lat'],
        'arrivedLocationLon': json['arrived_location_lon'] == null ? undefined : json['arrived_location_lon'],
        'actualDepartureDate': json['actual_departure_date'] == null ? undefined : json['actual_departure_date'],
        'actualDepartureAddress': json['actual_departure_address'] == null ? undefined : json['actual_departure_address'],
        'actualDepartureLat': json['actual_departure_lat'] == null ? undefined : json['actual_departure_lat'],
        'actualDepartureLon': json['actual_departure_lon'] == null ? undefined : json['actual_departure_lon'],
        'actualDestinationDate': json['actual_destination_date'] == null ? undefined : json['actual_destination_date'],
        'actualDestinationAddress': json['actual_destination_address'] == null ? undefined : json['actual_destination_address'],
        'actualDestinationLat': json['actual_destination_lat'] == null ? undefined : json['actual_destination_lat'],
        'actualDestinationLon': json['actual_destination_lon'] == null ? undefined : json['actual_destination_lon'],
        'activity': json['activity'] == null ? undefined : json['activity'],
        'radioNo': json['radio_no'] == null ? undefined : json['radio_no'],
        'plateNoUpper': json['plate_no_upper'] == null ? undefined : json['plate_no_upper'],
        'plateNoBottom': json['plate_no_bottom'] == null ? undefined : json['plate_no_bottom'],
        'carTypeCode': json['car_type_code'] == null ? undefined : json['car_type_code'],
        'carTypeName': json['car_type_name'] == null ? undefined : json['car_type_name'],
        'carRgb': json['car_rgb'] == null ? undefined : json['car_rgb'],
        'driverName': json['driver_name'] == null ? undefined : json['driver_name'],
        'driverId': json['driver_id'] == null ? undefined : json['driver_id'],
        'companyName': json['company_name'] == null ? undefined : json['company_name'],
        'companyCode': json['company_code'] == null ? undefined : json['company_code'],
        'subCompanyName': json['sub_company_name'] == null ? undefined : json['sub_company_name'],
        'subCompanyCode': json['sub_company_code'] == null ? undefined : json['sub_company_code'],
        'salesOfficeName': json['sales_office_name'] == null ? undefined : json['sales_office_name'],
        'salesOfficeId': json['sales_office_id'] == null ? undefined : json['sales_office_id'],
        'doorNo': json['door_no'] == null ? undefined : json['door_no'],
        'ownerDrivenTaxiName': json['owner_driven_taxi_name'] == null ? undefined : json['owner_driven_taxi_name'],
        'arrivalMessageSentDate': json['arrival_message_sent_date'] == null ? undefined : json['arrival_message_sent_date'],
        'desiredPaymentMethod': json['desired_payment_method'] == null ? undefined : json['desired_payment_method'],
        'paymentMethod': json['payment_method'] == null ? undefined : json['payment_method'],
        'settlementType': json['settlement_type'] == null ? undefined : json['settlement_type'],
        'actualFare': json['actual_fare'] == null ? undefined : json['actual_fare'],
        'estimateFare': json['estimate_fare'] == null ? undefined : json['estimate_fare'],
        'tollroadFee': json['tollroad_fee'] == null ? undefined : json['tollroad_fee'],
        'cancelDate': json['cancel_date'] == null ? undefined : json['cancel_date'],
        'cancelReasonName': json['cancel_reason_name'] == null ? undefined : json['cancel_reason_name'],
        'cancelFeeCollect': json['cancel_fee_collect'] == null ? undefined : json['cancel_fee_collect'],
    };
}

export function GetOrderDetail200ResponseToJSON(json: any): GetOrderDetail200Response {
    return GetOrderDetail200ResponseToJSONTyped(json, false);
}

export function GetOrderDetail200ResponseToJSONTyped(value?: GetOrderDetail200Response | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'update_timestamp': value['updateTimestamp'],
        'order_status': value['orderStatus'],
        'car_dispatch_status': value['carDispatchStatus'],
        'text': value['text'],
        'passenger_name': value['passengerName'],
        'member_type': value['memberType'],
        'passenger_tel': value['passengerTel'],
        'passenger_email': value['passengerEmail'],
        'order_no': value['orderNo'],
        'customer_id': value['customerId'],
        'request_source_type': value['requestSourceType'],
        'fare_type': value['fareType'],
        'route_type': value['routeType'],
        'order_type': value['orderType'],
        'fixed_fare_code': value['fixedFareCode'],
        'order_date': value['orderDate'],
        'departure_addr': value['departureAddr'],
        'departure_lat': value['departureLat'],
        'departure_lon': value['departureLon'],
        'departure_memo': value['departureMemo'],
        'destination_addr': value['destinationAddr'],
        'destination_lat': value['destinationLat'],
        'destination_lon': value['destinationLon'],
        'order_memo1': value['orderMemo1'],
        'order_memo2': value['orderMemo2'],
        'substituted': value['substituted'],
        'car_dispatch_date': value['carDispatchDate'],
        'estimated_departure_datetime': value['estimatedDepartureDatetime'],
        'arrived_location_date': value['arrivedLocationDate'],
        'arrived_location_address': value['arrivedLocationAddress'],
        'arrived_location_lat': value['arrivedLocationLat'],
        'arrived_location_lon': value['arrivedLocationLon'],
        'actual_departure_date': value['actualDepartureDate'],
        'actual_departure_address': value['actualDepartureAddress'],
        'actual_departure_lat': value['actualDepartureLat'],
        'actual_departure_lon': value['actualDepartureLon'],
        'actual_destination_date': value['actualDestinationDate'],
        'actual_destination_address': value['actualDestinationAddress'],
        'actual_destination_lat': value['actualDestinationLat'],
        'actual_destination_lon': value['actualDestinationLon'],
        'activity': value['activity'],
        'radio_no': value['radioNo'],
        'plate_no_upper': value['plateNoUpper'],
        'plate_no_bottom': value['plateNoBottom'],
        'car_type_code': value['carTypeCode'],
        'car_type_name': value['carTypeName'],
        'car_rgb': value['carRgb'],
        'driver_name': value['driverName'],
        'driver_id': value['driverId'],
        'company_name': value['companyName'],
        'company_code': value['companyCode'],
        'sub_company_name': value['subCompanyName'],
        'sub_company_code': value['subCompanyCode'],
        'sales_office_name': value['salesOfficeName'],
        'sales_office_id': value['salesOfficeId'],
        'door_no': value['doorNo'],
        'owner_driven_taxi_name': value['ownerDrivenTaxiName'],
        'arrival_message_sent_date': value['arrivalMessageSentDate'],
        'desired_payment_method': value['desiredPaymentMethod'],
        'payment_method': value['paymentMethod'],
        'settlement_type': value['settlementType'],
        'actual_fare': value['actualFare'],
        'estimate_fare': value['estimateFare'],
        'tollroad_fee': value['tollroadFee'],
        'cancel_date': value['cancelDate'],
        'cancel_reason_name': value['cancelReasonName'],
        'cancel_fee_collect': value['cancelFeeCollect'],
    };
}

